import { render, staticRenderFns } from "./Landlord.vue?vue&type=template&id=9ee127f8&"
import script from "./Landlord.vue?vue&type=script&lang=js&"
export * from "./Landlord.vue?vue&type=script&lang=js&"
import style0 from "./Landlord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports